export default "__VITE_ASSET__c7ffc05e__"